import React, { useState, useEffect, useRef } from "react";
import {
  Wrapper,
  ButtonWrapper,
  Box,
  Check,
  Shadow,
  Input,
  Label,
} from "./styled";

// props.value måste vara true eller false
const Checkbox = (props) => {
  const {
    label,
    value = "",
    checked,
    error,
    disabled,
    /* save = () => { }, */ name = "checkbox",
    onChange /* checkedValue */,
  } = props;

  const [isChecked, setIsChecked] = useState(checked);
  const [animate, setAnimate] = useState(false);
  const [focus, setFocus] = useState(false);

  const animateButton = () => {
    setAnimate(!animate);
    setTimeout(() => setAnimate(false), 400);
  };

  const onCheck = (e, animate = true) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (!disabled) {
      animate && animateButton();
      setIsChecked(!isChecked);
      onChange(value ? value : label);
    }
  };

  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      if (checked !== isChecked) {
        setIsChecked(checked);
      }
    } else {
      didMountRef.current = true;
    }
  }, [checked, isChecked]);

  return (
    <Wrapper className={isChecked ? "is-checked" : ""}>
      <ButtonWrapper
        onClick={(e) => onCheck(e)}
        disabled={disabled}
        aria-label={label || "Checkbox"}
      >
        <Box checked={isChecked} disabled={disabled} error={error}>
          {isChecked ? <Check className="far fa-check" /> : ""}
        </Box>
        <Shadow className={animate ? "animate" : ""} focus={focus} />
        <Input
          name={`${name}-1`}
          id={props.id}
          type="checkbox"
          onClick={(e) => onCheck(e)}
          disabled={disabled}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
        />
      </ButtonWrapper>
      {label && (
        <Label
          htmlFor={props.id}
          onClick={(e) => onCheck(e)}
          disabled={disabled}
          error={error}
        >
          {label}
        </Label>
      )}
    </Wrapper>
  );
};

export default Checkbox;
